import React, { useEffect, useState } from 'react';

import { useAppSelector, useAppDispatch } from '../store/hooks';
import { selectNotificationMessage, selectNotificationVisible, selectNotificationYPosition } from '../store/selectors';
import { hideNotification } from '../store/slices/notificationSlice';
import './Notification.css';

export interface NotificationProps {
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({ duration = 2000 }) => {
  const dispatch = useAppDispatch();
  const message = useAppSelector(selectNotificationMessage);
  const isVisible = useAppSelector(selectNotificationVisible);
  const yPosition = useAppSelector(selectNotificationYPosition);

  const [animationState, setAnimationState] = useState<'entering' | 'visible' | 'exiting' | 'hidden'>('hidden');

  useEffect(() => {
    let enterTimeout: NodeJS.Timeout;
    let exitTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;

    if (isVisible) {
      setAnimationState('entering');

      enterTimeout = setTimeout(() => {
        setAnimationState('visible');
      }, 300);

      exitTimeout = setTimeout(() => {
        setAnimationState('exiting');
      }, duration);

      hideTimeout = setTimeout(() => {
        dispatch(hideNotification());
        setAnimationState('hidden');
      }, duration + 300);
    } else {
      setAnimationState('hidden');
    }

    return () => {
      clearTimeout(enterTimeout);
      clearTimeout(exitTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isVisible, duration, dispatch]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`playmerce-notification ${animationState}`}>
      <div className="notification-content">{message}</div>
    </div>
  );
};

export default Notification;
